<template>
    <div
        class="px-3 sm:px-6 pt-40 pb-12 z-10 bg-iglu"
    >
        <div
            class="relative flex flex-col items-center w-full max-w-screen-sm mx-auto border-2 border-orange p-6 sm:p-16 bg-white"
        >
            <back-button></back-button>

            <brush-stroke-bg :variant="2" class="mb-10">
                <h2 class="font-primary text-white text-3xl px-6 sm:px-12">
                    {{ $config("LOGIN") }}
                </h2>
            </brush-stroke-bg>

            <ValidationObserver v-slot="{ handleSubmit }" class="w-full">
                <form
                    @submit.prevent="handleSubmit(login)"
                    autocomplete="on"
                    class="flex flex-col items-center"
                    novalidate
                >
                    <form-input
                        name="email"
                        type="email"
                        v-model="email"
                        :placeholder="$config('EMAIL')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <form-input
                        name="password"
                        type="password"
                        v-model="password"
                        :placeholder="$config('PASSWORD')"
                        class="w-full mb-2"
                        required
                    ></form-input>

                    <router-link
                        class="w-full font-secondary text-blue text-right mb-10"
                        :to="{ name: 'forgot-password' }"
                        >{{ $config("LOST_PASSWORD") }}</router-link
                    >

                    <btn
                        class="bg-orange text-white text-xl rounded-large px-10 mb-8"
                        >{{ $config("LOGIN") }}</btn
                    >
                </form>
            </ValidationObserver>

            <p class="font-secondary text-blue mb-8">
                {{ $config("NO_REGISTER") }}
            </p>

            <btn
                class="bg-orange text-white text-xl rounded-large px-10"
                :to="{ name: 'register-sign-up' }"
                >{{ $config("SIGN_HERE") }}</btn
            >
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import allowGuestsOnly from "../mixins/allowGuestsOnly";
import BackButton from "../components/BackButton";
import BrushStrokeBg from "../components/BrushStrokeBg";
import FormInput from "../components/FormInput";
import Btn from "../components/Btn";
import requestWithInteractions from "../mixins/requestWithInteractions";
import api from "../api";

export default {
    name: "login",

    components: { BackButton, BrushStrokeBg, FormInput, Btn },

    mixins: [allowGuestsOnly, requestWithInteractions],

    data() {
        return {
            email: "",
            password: ""
        };
    },

    computed: {
        ...mapGetters(["registerOrHomeRoute"])
    },

    methods: {
        async login() {
            this.sendRequest(api.login(this.email, this.password), {
                beforeSendText: this.$config("LOGIN"),
                successText: this.$config("BIENVENIDO"),

                failureCondition: response => {
                    return !response.success;
                },
                onSuccess: response => {
                    this.$store.commit(
                        "SET_AUTHENTICATED_USER",
                        response.userdata
                    );
                    this.$store.commit(
                        "SET_AUTHENTICATED_USER_ACCESS",
                        response.access
                    );

                    this.$router.push(this.registerOrHomeRoute);
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.bg-iglu {
  background: url('~@/assets/img/fondos_pinguiigluu.jpg') center center/cover no-repeat !important;
}
</style>